import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import VideoForm from "./VideoForm";

export default function AddVideoModal({ handleOut }) {
    const isEdit = useSelector(state=>state.edit?.isEdit);
    return (
        <div>
            <div className="w-full p-6 flex justify-between items-center">
                <div className='text-2xl font-bold text-cyan'>
                    {isEdit? "Edit Video" : "ADD VIDEO"}
                    </div>
                <div onClick={handleOut} className='p-2 cursor-pointer'><MdCancel /></div>
            </div>
            <VideoForm handleOut={handleOut} />
        </div>
    )
};